var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.is,_vm._g({tag:"component",staticClass:"badge cta-button no-outline",class:( _obj = {
		'cta-button--disabled': _vm.disabled,
		'cta-button--reverse': _vm.isReversed,
		'cta-button--forward': !_vm.isReversed,
		'cta-button--solid': _vm.isSolid && !_vm.isLink,
		'cta-button--link': _vm.isLink && !_vm.isSolid,
		'cta-button--outline': !_vm.isSolid && !_vm.isLink,
		'cta-button--loading': _vm.isLoading,
		'cta-button--active': _vm.isActive,
		'cta-button--merged': _vm.isMerged,
		'cta-button--wrap': _vm.wrap,
		'badge--inline': _vm.size === _vm.Size.INLINE,
		'badge--tiny': _vm.size === _vm.Size.TINY,
		'badge--small': _vm.size === _vm.Size.SMALL,
		'badge--medium': _vm.size === _vm.Size.MEDIUM,
		'badge--large': _vm.size === _vm.Size.LARGE,
		'badge--extra-large': _vm.size === _vm.Size.EXTRA_LARGE
	}, _obj[_vm.paletteClass] = true, _obj ),attrs:{"type":"button"},on:{"mousedown":function($event){$event.preventDefault();return _vm.$emit('mousedown', $event)},"click":_vm.handleClick}},_vm.nonClickListeners),[(_vm.hasIcon)?[_vm._t("icon",null,{"classes":{
				'cta-button__icon-with-content': true,
			}}),_c('span',{staticClass:"cta-button__content-with-icon"},[_vm._t("default")],2)]:_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }